import type React from 'react';

import * as styles from './styles';

import { type AccessibleFleet, Location, type UUID } from '@cobliteam/common-types';

import { MenuItem, MenuItemType } from '@cobliteam/base-components';

import Icon from '@cobliteam/ui/icons';

import Popover, { PopoverContent, PopoverTrigger } from '@cobliteam/ui/components/Popover';
import { SidebarItemDropdownEntry } from '../SidebarItemDropdownEntry/SidebarItemDropdownEntry';

export interface SidebarFleetProps {
  accessibleFleets: AccessibleFleet[];
  changeUserFleet: (fleet: AccessibleFleet) => void;
  currentFleetId: UUID | false;
}

export const SidebarFleet: React.FC<SidebarFleetProps> = ({ accessibleFleets, changeUserFleet, currentFleetId }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>, fleet: AccessibleFleet) => {
    event.preventDefault();

    changeUserFleet(fleet);
  };

  const sortedAccessibleFleets = accessibleFleets.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Popover>
      <PopoverTrigger>
        <div className={styles.sidebarItem}>
          <div className={styles.iconWrapper(false)}>
            <Icon name='cb-filters-vehicle-group-cb' />
          </div>
          <MenuItem active={false} type={MenuItemType.LIGHT}>
            Trocar de frota
            <div className={styles.iconWrapper(false)}>
              <Icon name='chevron-right' />
            </div>
          </MenuItem>
        </div>
      </PopoverTrigger>

      <PopoverContent
        portal={false}
        align='start'
        side='right'
        showArrow={false}
        className='max-h-[100vh] w-[300px] overflow-auto rounded-none border-none bg-gray-12 p-0'
        sideOffset={0}
      >
        {sortedAccessibleFleets.map((fleet) => (
          <div key={fleet.id}>
            <SidebarItemDropdownEntry onClickCapture={(event) => handleClick(event, fleet)} location={Location.MONITORING} active={currentFleetId === fleet.id} key={fleet.id}>
              <div className='flex flex-row justify-between gap-4'>
                {currentFleetId === fleet.id && <Icon name='check' />}
                <div className='line-clamp-1'>{fleet.name}</div>
              </div>
            </SidebarItemDropdownEntry>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
};
